import React from "react";
import _ from "lodash";
import { Responsive, WidthProvider } from "react-grid-layout";
import './ChartDashboardViewr.css';

import { ReactComponent as HandIcon } from '../icons/hand.svg';
import { ReactComponent as SaveIcon } from '../icons/home/save.svg';
import { ReactComponent as TrashIcon } from '../icons/home/trash.svg';
import { ReactComponent as ExportIcon } from '../icons/home/export.svg';
import { ReactComponent as CopyIcon } from '../icons/home/copy.svg';
import { ReactComponent as SideDashFilters } from '../icons/filters.svg';
import { ReactComponent as SideDashChart } from '../icons/sideDashChart.svg';
import { ReactComponent as SideDashHeading } from '../icons/sideDashHeading.svg';
import { ReactComponent as SideDashPalette } from '../icons/sideDashPalette.svg';
import { ReactComponent as SideDashUp } from '../icons/sideDashUp.svg';
import { ReactComponent as SideDashDown } from '../icons/sideDashDown.svg';

import axios from 'axios';
import { API_BASE_URL, ChartWidget, fetchData, makePostRequest} from './Common';

const ResponsiveReactGridLayout = WidthProvider(Responsive);

const themeMap = {
  // Themes with white border
  1: { name: 'Baby Blue', backgroundColor: '#e3f2fd', border: '2px solid #ffffff', color: '#000' },
  2: { name: 'Peach', backgroundColor: '#ffe0b2', border: '2px solid #ffffff', color: '#000' },
  3: { name: 'Lime Green', backgroundColor: '#f1f8e9', border: '2px solid #ffffff', color: '#000' },
  4: { name: 'Soft Pink', backgroundColor: '#fce4ec', border: '2px solid #ffffff', color: '#000' },
  5: { name: 'Cool Gray', backgroundColor: '#e0e0e0', border: '2px solid #ffffff', color: '#000' },
  6: { name: 'Warm Beige', backgroundColor: '#f5f5dc', border: '2px solid #ffffff', color: '#000' },
  7: { name: 'Aqua', backgroundColor: '#e0f7fa', border: '2px solid #ffffff', color: '#000' },
  8: { name: 'Pink', backgroundColor: '#ffebee', border: '2px solid #ffffff', color: '#000' },
  9: { name: 'Light Coral', backgroundColor: '#ffcccb', border: '2px solid #ff1493', color: '#000' },
  10: { name: 'Beige', backgroundColor: '#f5f5dc', border: '2px solid #d2b48c', color: '#000' },

  // Other themes
  11: { name: 'Lavender', backgroundColor: '#e6e6fa', border: '2px solid #4b0082', color: '#000' },
  12: { name: 'Ocean Blue', backgroundColor: '#e0f7fa', border: '2px solid #00796b', color: '#000' },
  13: { name: 'Sunset Orange', backgroundColor: '#ffecb3', border: '2px solid #ff5722', color: '#000' },
  14: { name: 'Forest Green', backgroundColor: '#c8e6c9', border: '2px solid #388e3c', color: '#000' },
  15: { name: 'Sky Gray', backgroundColor: '#f5f5f5', border: '2px solid #607d8b', color: '#000' },
  16: { name: 'Cherry Blossom', backgroundColor: '#f8bbd0', border: '2px solid #c2185b', color: '#000' },
  17: { name: 'Powder Blue', backgroundColor: '#b0e0e6', border: '2px solid #4682b4', color: '#000' },
  18: { name: 'Royal Purple', backgroundColor: '#d1c4e9', border: '2px solid #6200ea', color: '#000' },
  19: { name: 'Sand Beige', backgroundColor: '#ffebee', border: '2px solid #795548', color: '#000' },
  20: { name: 'Mint Green', backgroundColor: '#e0f2f1', border: '2px solid #004d40', color: '#000' },
  21: { name: 'Coral Reef', backgroundColor: '#ffccbc', border: '2px solid #ff5722', color: '#000' },
  22: { name: 'Plum', backgroundColor: '#d1c4e9', border: '2px solid #8e24aa', color: '#000' },
  23: { name: 'Alice Blue', backgroundColor: '#f0f8ff', border: '2px solid #00f', color: '#000' },
  24: { name: 'Blanched Almond', backgroundColor: '#ffebcd', border: '2px solid #8b4513', color: '#000' },
  25: { name: 'Linen', backgroundColor: '#faf0e6', border: '2px solid #deb887', color: '#000' },
};

export default class DragFromOutsideLayout extends React.Component {

  static defaultProps = {
    className: "layout",
    rowHeight: 30,
    onLayoutChange: function() {},
    cols: { lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 },
  };

  state = {
    isDragging: false,
    currentBreakpoint: "lg",
    compactType: "vertical",
    mounted: false,
    layouts: { lg: generateLayout(WidgetsData(this.props.dashboard, this.props.widgets)) },
    widgets_data: WidgetsData(this.props.dashboard, this.props.widgets),//trigger generateLayout rerender on change
    isDraggable: false,
    theme2: 5,
    selectedWidgetIds: [],
    filteredData: this.props.tableColumnData,
    dropdownSelections: {},
    stateWidgets:this.props.widgets,
  };

  componentDidMount() {
    this.setState({ mounted: true });
    const { dashboard } = this.props;
    this.setState({ theme2: dashboard.theme });
}

  generateDOM() {

    return Object.keys(this.state.widgets_data).map(widgetId => {
      const widget = this.state.widgets_data[widgetId];
      const widgetKey = Object.keys(widget)[0];
      return (
        <div key={widgetId} className={widget.static ? "static" : ""}>
            <div className="widget-container1"
            style={{
                border: themeMap[this.state.theme2].border,
                backgroundColor: themeMap[this.state.theme2].backgroundColor,
            }}>

            <span className="widget-title1">
            {widget[widgetKey].name.toString()}</span>
            {((this.props.permission !== "read-only") && (this.props.permission !== "URL")) && (
            <button onClick={() => this.handleDelete(widgetId)}
            className="delete-button1"
            >
              x
            </button>
            )}
<ChartWidget
  Id={widgetId}
  tableColumnData={this.state.filteredData}
  widget={widget}
  height={'100%'}
  tables={this.props.tables}
/>
            </div>
        </div>
      );
    });

  }

  onBreakpointChange = breakpoint => {
    this.setState({
      currentBreakpoint: breakpoint
    });
  };

  onCompactTypeChange = () => {
    const { compactType: oldCompactType } = this.state;
    const compactType =
      oldCompactType === "horizontal"
        ? "vertical"
        : oldCompactType === "vertical"
        ? null
        : "horizontal";
    this.setState({ compactType });
  };



















//********************************************************************************
onLayoutChange = (layout, layouts) => {
    if (!this.state.isDragging) {
    this.props.onLayoutChange(layout, layouts);
    this.updateDatabase(layout);
    }
  };

handleDelete = async (widgetId) => {
  // Remove widget from state
  const newLayouts = { ...this.state.layouts };
  Object.keys(newLayouts).forEach(breakpoint => {
    newLayouts[breakpoint] = newLayouts[breakpoint].filter(layout => layout.i !== widgetId);
  });

  const newWidgetsData = { ...this.state.widgets_data };
  delete newWidgetsData[widgetId];

  this.setState({
    layouts: newLayouts,
    widgets_data: newWidgetsData,
  });

  const { DashboardId } = this.props;
  const token = localStorage.getItem('token');

  try {
    let response;

    if (this.state.stateWidgets[widgetId].label_id === 0) {
      // Use the DELETE endpoint when label_id is 0
      response = await axios.delete(`${API_BASE_URL}/widgets/${widgetId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
    } else {
      // Default POST endpoint when label_id is not 0
      response = await axios.post(`${API_BASE_URL}/delete-element`,
        { widgetId, DashboardId },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
    }

    console.log('Element deleted successfully:', response.data);
  } catch (error) {
    console.error('Error deleting element:', error);
  }
};


  saveThemeToDatabase = async (themeNumber) => {
  const { DashboardId } = this.props;

  await makePostRequest(`${API_BASE_URL}/update-theme`, {
    DashboardId,
    themeNumber
  });
};

updateDatabase = async (layout) => {
  const { DashboardId} = this.props;




  try {
    const token = localStorage.getItem('token');
    await axios.post(`${API_BASE_URL}/update-layout`, { layout, DashboardId }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });
  /*await makePostRequest(`${API_BASE_URL}/update-layout`, {
    layout,
    DashboardId,
  });*/

    fetchData(`${API_BASE_URL}/widgets/${this.props.projectId}`, this.props.setWidgets, this.props.setIsWidgetsLoaded, 'widgetData');

    fetchData(
  `${API_BASE_URL}/dashboards/${this.props.projectId}`,
  this.props.setDashboards,
  this.props.setIsDashboardsLoaded,
  'dashboardData'
).then(() => {
  //console.log("olá");
});

} catch (error) {
  }
};

handleCreateElement = async (graphType, conteudo) => {
  try {
    const token = localStorage.getItem('token');

const newWidgetData = {
      projectId: this.props.projectId,
      graphType: graphType,
      conteudo: conteudo,
      label: '0',
      name: "",
      dataset: null
    };

    const response = await axios.post(`${API_BASE_URL}/widgets`, newWidgetData, {
      headers: {
        Authorization: `Bearer ${token}` // Include JWT token in Authorization header
      }
    });

    const widget_id = Object.keys(response.data.duplicatedWidget)[0];

    return widget_id;
  } catch (error) {
    return null;
  }
};

onDrop = (layout, layoutItem, _event) => {

    const convertWidgetsDataToArray = (widgets_data) => {
        return Object.keys(widgets_data).map(key => {
            const widgetDetails = widgets_data[key].widget_id; // Accessing the widget_id object
            return {
                widget_id: key,  // Use the key as widget_id
                size: null,  // Assuming size should be populated from widgetDetails
                x: widgetDetails.x,
                y: widgetDetails.y,
                w: widgetDetails.w,
                h: widgetDetails.h,
            };
        });
    };

    const createNewWidget = (widget_id, layoutItem) => {
        return {
            widget_id: widget_id,
            size: null,
            x: layoutItem.x,
            y: layoutItem.y,
            w: layoutItem.w,
            h: layoutItem.h,
        };
    };

    const handleWidgetCreation = (widgetData, conteudo, graph_type) => {
        const updatedDashboard = {
            ...this.props.dashboard,
            widgets: [...convertWidgetsDataToArray(this.state.widgets_data), widgetData],  // Add the new widget
        };

        let combinedWidgets;

if (conteudo) {
combinedWidgets = {
    ...this.state.stateWidgets, // Spread operator to copy existing widgets
    [widgetData.widget_id]: {   // New entry for widgetData
        "label_id": 0,
        "name": "",
        "graph_type": graph_type, // Assuming the graph_type is a unique identifier
        "columns": [null],
        "conteudo": conteudo,
        "permission": null
    }
};
    } else combinedWidgets = this.state.stateWidgets;

        const updatedWidgetsData = WidgetsData(updatedDashboard, combinedWidgets);

        const updatedLayouts = generateLayout(updatedWidgetsData);

        this.updateDatabase(updatedLayouts);

        this.setState(
            {
                layouts: { ...this.state.layouts, lg: updatedLayouts }, // update layouts
                widgets_data: updatedWidgetsData, // also update widgets_data
                stateWidgets: combinedWidgets,
            },
            () => {
                // This callback will be called after the state has been updated
                this.setState({ isDragging: false }); // Now you can set isDragging to false
            }
        );
    };

    let widget_id;

    if (
        _event.dataTransfer.getData('elementType') === 'Imagem' ||
        _event.dataTransfer.getData('elementType') === 'Parágrafo' ||
        _event.dataTransfer.getData('elementType') === 'Título'
    ) {
        let graph_type, conteudo;

        switch (_event.dataTransfer.getData('elementType')) {
            case 'Imagem':
                graph_type = '102';
                conteudo = 'images/prochild.png';
                break;
            case 'Parágrafo':
                graph_type = '101';
                conteudo = 'Parágrafo';
                break;
            case 'Título':
                graph_type = '100';
                conteudo = 'Título';
                break;
            default:
                return; // Exit if no valid type
        }

        this.handleCreateElement(graph_type, conteudo)
            .then((widget_id) => {
                const newWidget = createNewWidget(widget_id, layoutItem);
                handleWidgetCreation(newWidget, conteudo, graph_type);
            })
            .catch((error) => {
                console.error('Error creating widget:', error);
            });
    } else {
        widget_id = _event.dataTransfer.getData('widget_id');
        const newWidget = createNewWidget(widget_id, layoutItem);
        handleWidgetCreation(newWidget, null, null);
    }
};


onDropDragOver = (event) => {
  // Return the placeholder size during drag over event
  return { w: 3, h: 5 };  // Set the placeholder size to 3x5 during drag
};
//****************************************************************************************



















  render() {
    const { tables, dashboard, widgets, DashboardId, permission, onSave, onExport, onDelete, onDuplicate, tableColumnData } = this.props;

function filterTableData(columnId, selectedValue, datatoFilter) {
    const colunas = getColumnIds([Number(columnId)]);
    const newFilteredData = {};

    // Step 1: Find matching row indices based on selectedValue in the specified columnId
    const matchingIndices = datatoFilter[Number(columnId)].data.reduce((indices, value, index) => {
        if (value === selectedValue) {
            indices.push(index);
        }
        return indices;
    }, []);

    // Step 2: Filter the relevant columns in colunas
    colunas.forEach((id) => {
        if (datatoFilter[id]) {
            const columnData = datatoFilter[id];
            // Create a new entry in newFilteredData for each filtered column
            newFilteredData[id] = {
                column_name: columnData.column_name,
                data: matchingIndices.map(index => columnData.data[index]),
                row_id: matchingIndices.map(index => columnData.row_id[index]),
            };
        }
    });

    // Step 3: Include all other columns not in colunas unfiltered
    Object.keys(datatoFilter).forEach((id) => {
        if (!colunas.includes(Number(id))) {
            const columnData = datatoFilter[id];
            // Copy the full data for non-filtered columns
            newFilteredData[id] = {
                column_name: columnData.column_name,
                data: columnData.data,
                row_id: columnData.row_id,
            };
        }
    });

    return newFilteredData;
}

const handleDropdownChange = (columnId, selectedValue) => {

  const updatedSelections = {
    ...this.state.dropdownSelections,
    [columnId]: selectedValue
  };

    let filtered = tableColumnData;
    Object.entries(updatedSelections).forEach(([key, value]) => {
    if (value) filtered = filterTableData(key, value, filtered);
    });

this.setState({ dropdownSelections: updatedSelections });
this.setState({ filteredData: filtered });
  };

const getUniqueValues = (columnId) => {
    const columnData = tableColumnData[columnId];
    if (columnData) {
      return [...new Set(columnData.data)]; // Extract unique values
    }
    return []; // Return an empty array if the column does not exist
  };

  function getColumnIds(labelIds) {
    const columnIds = Object.values(tables).flatMap(table =>
        table.columns.some(column => labelIds.includes(column.column_id))
            ? table.columns.map(column => column.column_id)
            : []
    );
    return columnIds;
}

    const widgetIds = dashboard.widgets.map(widget => widget.widget_id);
    const labelIds = widgetIds
  .filter(widgetId => widgets[widgetId])
  .map(widgetId => widgets[widgetId].label_id);

const showMessage = Object.keys(this.state.widgets_data).length === 0;

const { isElementosVisible, isWidgetsVisible, isTemasVisible, isFiltrosVisible } = this.state;

const widgetIdsInData = new Set(Object.keys(this.state.widgets_data));

const unusedWidgets = Object.fromEntries(
  Object.entries(widgets).filter(([widgetId, widget]) => !widgetIdsInData.has(widgetId))
);

const nonElementWidgets = Object.keys(unusedWidgets)
    .filter(key => unusedWidgets[key].label_id !== 0)
    .reduce((result, key) => {
        result[key] = unusedWidgets[key];
        return result;
    }, {});

const IconButton = ({ Icon, action, dashboardId, permission }) => {
  const isReadOnly = permission === 'read-only';

  return (
    <Icon
      onClick={() => !isReadOnly && action(dashboardId)}
      style={{
        cursor: isReadOnly ? 'not-allowed' : 'pointer',
        opacity: isReadOnly ? 0.5 : 1
      }}
      disabled={isReadOnly}
    />
  );
};

const toggleSelection = (widgetId) => {
  this.setState(prevState => ({
    selectedWidgetIds: prevState.selectedWidgetIds.includes(widgetId)
      ? prevState.selectedWidgetIds.filter(id => id !== widgetId) // Remove if already selected
      : [...prevState.selectedWidgetIds, widgetId] // Add if not selected
  }));
};

    return (
      <>
      <div className="project-info">
      <span>{""}</span>
      <div className="icons-container">

{permission !== "URL" && (<>
      <button
  onClick={() => {
    if (permission === "read-only") return; // Do nothing if permission is read-only

    this.onCompactTypeChange(); // Call your function to handle button click
  }}
  style={{
    padding: "10px 20px",
    backgroundColor: permission === "read-only" ? "#6c757d" : "#007bff",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: permission === "read-only" ? "not-allowed" : "pointer",
    opacity: permission === "read-only" ? 0.5 : 1,
  }}
  disabled={permission === "read-only"} // Disable button if permission is read-only
>
  {_.capitalize(this.state.compactType) || "No Compaction"}
</button>


<button
  onClick={() => {
    if (permission === "read-only") return; // Do nothing if permission is read-only

    this.setState((prevState) => ({ isDraggable: !prevState.isDraggable }));
  }}
  style={{
    padding: "10px 20px",
    backgroundColor: permission === "read-only" ? "#6c757d" : (this.state.isDraggable ? "#28a745" : "#dc3545"),
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: permission === "read-only" ? "not-allowed" : "pointer",
    marginLeft: "10px",
    opacity: permission === "read-only" ? 0.5 : 1,
  }}
  disabled={permission === "read-only"} // Disable button if permission is read-only
>
  {permission === "read-only" ? "Dragging OFF" : (this.state.isDraggable ? "Dragging ON" : "Dragging OFF")}
</button>

<IconButton
  Icon={SaveIcon}
  action={onSave}
  dashboardId={DashboardId}
  permission={permission}
/>

  <IconButton
  Icon={TrashIcon}
  action={onDelete}
  dashboardId={DashboardId}
  permission={permission}
/>

<IconButton
  Icon={CopyIcon}
  action={onDuplicate}
  dashboardId={DashboardId}
  permission={permission}
/>

<ExportIcon
        onClick={() => onExport(DashboardId)}
        style={{ cursor: 'pointer' }}
  />
  </>)}
            </div>
            </div>


      <div className="main-content2">
{((permission !== "read-only") && (permission !== "URL")) && (



        <div className="sidebar2">
{/*------------------------------------------------------------------------------------*/}
      <div className="category2">
        <h3 onClick={() => {
    this.setState(prevState => ({ isElementosVisible: !prevState.isElementosVisible }));
  }} style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', borderBottom: '1px solid #233C7E40' }}>
          <SideDashHeading style={{ marginRight: '8px', verticalAlign: 'middle' }} />
          Elementos
          {isElementosVisible ? (
  <SideDashUp style={{ marginLeft: '8px', verticalAlign: 'middle' }} />
) : (
  <SideDashDown style={{ marginLeft: '8px', verticalAlign: 'middle' }} />
)}
        </h3>
        {isElementosVisible && (
  <div className="scrollable-content">
  {['Parágrafo', 'Título', 'Imagem'].map((name, index) => (
    <div
      key={`category1-${index}`}
      className="droppable-element2"
      draggable={true}
      unselectable="on"
      onDragStart={(e) => e.dataTransfer.setData('elementType', name)} // Updated line
    >
      {name}
    </div>
  ))}
</div>

)}

      </div>
{/*------------------------------------------------------------------------------------*/}
      <div className="category2">
        <h3
        onClick={() => {
    this.setState(prevState => ({ isWidgetsVisible: !prevState.isWidgetsVisible }));
  }}

  style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', borderBottom: '1px solid #233C7E40' }}>
          <SideDashChart style={{ marginRight: '8px', verticalAlign: 'middle' }} />
          Widgets
          {isWidgetsVisible ? (
  <SideDashUp style={{ marginLeft: '8px', verticalAlign: 'middle' }} />
) : (
  <SideDashDown style={{ marginLeft: '8px', verticalAlign: 'middle' }} />
)}
        </h3>
        {isWidgetsVisible && (
          <div className="scrollable-content">
            {Object.entries(nonElementWidgets).map(([widget_id, widget], index) => (
  <div
    key={`category2-${index}`}
    className="droppable-element2"
    draggable={true}
    unselectable="on"
    onDragStart={(e) => {
      this.setState({ isDragging: true });
      e.dataTransfer.setData('widget_id', widget_id);
      e.dataTransfer.setData('elementType', 'newWidget');
    }}
  >
    {widget.name}
  </div>
))}
          </div>
        )}
      </div>
{/*------------------------------------------------------------------------------------*/}
<div className="category2">
        <h3
          onClick={() => {this.setState(prevState => ({ isTemasVisible: !prevState.isTemasVisible }));}}

          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', borderBottom: '1px solid #233C7E40' }}>
          <SideDashPalette style={{ marginRight: '8px', verticalAlign: 'middle' }} />
          Temas
          {isTemasVisible ? (
  <SideDashUp style={{ marginLeft: '8px', verticalAlign: 'middle' }} />
) : (
  <SideDashDown style={{ marginLeft: '8px', verticalAlign: 'middle' }} />
)}
        </h3>
        {isTemasVisible && (
    <div className="scrollable-content">
      {Object.entries(themeMap).map(([themeNumber, { name, ...styles }]) => (
        <div
          key={themeNumber}
          className="temas-button"
          onClick={() => {
            this.setState({ theme2: Number(themeNumber), ...styles }, () => {
  this.saveThemeToDatabase(Number(themeNumber)); // Save theme number to the database
});
          }}
          style={{ margin: '5px', ...styles }}
        >
          {name}
        </div>
      ))}
    </div>
  )}
      </div>
{/**************************************************************/}
      <div className="category2">
        <h3
          onClick={() => {this.setState(prevState => ({ isFiltrosVisible: !prevState.isFiltrosVisible }));}}

          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', borderBottom: '1px solid #233C7E40' }}>
          <SideDashFilters style={{ marginRight: '8px', verticalAlign: 'middle' }} />
          Filtros
          {isFiltrosVisible ? (
  <SideDashUp style={{ marginLeft: '8px', verticalAlign: 'middle' }} />
) : (
  <SideDashDown style={{ marginLeft: '8px', verticalAlign: 'middle' }} />
)}
        </h3>
        {isFiltrosVisible && (
    <div className="scrollable-content">
      {getColumnIds(labelIds).map(columnId => (
         <div
              key={columnId}
              onClick={() => toggleSelection(columnId)}
              className="droppable-element2"
              style={{
                cursor: 'pointer', // Change cursor to indicate clickable item
                backgroundColor: this.state.selectedWidgetIds.includes(columnId) ? '#e0e0e0' : 'transparent', // Background color for selected items
                border: this.state.selectedWidgetIds.includes(columnId) ? '1px solid #007bff' : '1px solid transparent', // Border for selected items
                borderRadius: '4px', // Rounded corners for all items
                transition: 'background-color 0.3s, border 0.3s' // Smooth transition effect
              }}
            >
              {tableColumnData[columnId]?.column_name}
            </div>
      ))}
    </div>
  )}
      </div>
{/**************************************************************/}
{this.state.selectedWidgetIds.length > 0 && (
  <div className="dropdown-filter-container">
    {this.state.selectedWidgetIds.map(columnId => (
      <div key={columnId} className="dropdown-filter-item">
        <label htmlFor={`dropdown-${columnId}`}>
          {tableColumnData[columnId]?.column_name}
        </label>
        <select
          id={`dropdown-${columnId}`}
          onChange={(e) => handleDropdownChange(columnId, e.target.value)}
        >
          <option value="">Selecionar</option>
          {getUniqueValues(columnId).map(option => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>
    ))}
  </div>
)}

    </div>
)}
          <div className="dashboard2">
        <div style={{ position: 'relative', height: '455px' }}>
{showMessage && (
<div className="empty-message">
          <HandIcon/>
            Arraste e solte elemento para aqui
          </div>
        )}
        <ResponsiveReactGridLayout
          {...this.props}
          layouts={this.state.layouts}
          onBreakpointChange={this.onBreakpointChange}
          onLayoutChange={this.onLayoutChange}
          onDrop={this.onDrop}
          onDropDragOver={this.onDropDragOver}
          measureBeforeMount={false}
          // animate on mount. If you don't, delete `useCSSTransforms` (it's default `true`)
          // and set `measureBeforeMount={true}`.
          useCSSTransforms={this.state.mounted}
          compactType={this.state.compactType}
          preventCollision={!this.state.compactType}
          isDroppable={true}
          isDraggable={this.state.isDraggable}
          isResizable={this.state.isDraggable}
        >
          {this.generateDOM()}
        </ResponsiveReactGridLayout>
        </div>
      </div>
      </div>
      </>
    );
  }
}

function generateLayout(widgets_data) {

  return Object.keys(widgets_data).map((widgetId, index) => {
    const widget = widgets_data[widgetId];
    const widgetKey = Object.keys(widget)[0];

    return {
      x: widget[widgetKey].x,
      y: widget[widgetKey].y,
      w: widget[widgetKey].w,
      h: widget[widgetKey].h,
      i: widgetId,
      //resizeHandles: ["sw", "nw", "se", "ne"],
      resizeHandles: ["sw", "nw", "se"],
      static: false
    };
  });
}

function WidgetsData(dashboard, widgets) {

  let widgets_data = {};
  for (let widget of dashboard.widgets) {   //console.log(widget);
    if (widget.widget_id !== null) {
      widgets_data[widget.widget_id] = {
        widget_id: {
          ...widgets[widget.widget_id],
          size: widget.size,
          x: widget.x,
          y: widget.y,
          w: widget.w,
          h: widget.h
        }
      };
    }
  }
  return widgets_data;
}
